import { useEffect } from 'react'

/**
 * BlogPosting JSON-LD for individual articles (rich results / discovery).
 * @param {{ slug: string, title: string, description?: string, date?: string, keywords?: string }} post
 * @param {string} pageUrl ,  canonical page URL for this locale (absolute).
 */
export function BlogPostingJsonLd({ id = 'pds-blog-posting-jsonld', post, pageUrl }) {
  useEffect(() => {
    if (typeof document === 'undefined' || !post?.slug || !pageUrl) return undefined
    const url = pageUrl
    const orgId = 'https://primedocumentsign.com/#organization'
    const payload = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.title,
      description: post.description,
      datePublished: post.date,
      author: { '@id': orgId },
      publisher: { '@id': orgId },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': url,
      },
      url,
      keywords: post.keywords,
    }
    let el = document.getElementById(id)
    if (!el) {
      el = document.createElement('script')
      el.id = id
      el.type = 'application/ld+json'
      document.head.appendChild(el)
    }
    el.textContent = JSON.stringify(payload)
    return () => {
      el?.remove()
    }
  }, [id, post, pageUrl])
  return null
}
